import { render, staticRenderFns } from "./DuplicatedProductsManagement.vue?vue&type=template&id=13ff6b00&"
import script from "./DuplicatedProductsManagement.vue?vue&type=script&lang=ts&"
export * from "./DuplicatedProductsManagement.vue?vue&type=script&lang=ts&"
import style0 from "./DuplicatedProductsManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports